import styles from "./right-side-clips.styles.module.scss";
import { useContext, useState, useEffect } from "react";
import OnBoardingStepOne from "./onboarding-step-one-video/onboarding-step-one-video.component";
import { AppContext } from "../../../app.context";
import { OnboardingSteps } from "../../../app.constants";
import classNames from "classnames";
import StepTwoSvg from "../../../assets/images/onboarding-step-two.svg";
import StepThreeSvg from "../../../assets/images/onboarding-step-three.svg";
import { useTranslation } from "react-i18next";

const RightSideClips = () => {
  const { step } = useContext(AppContext);
  const [displayedStep, setDisplayedStep] = useState(step);
  const { t } = useTranslation();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDisplayedStep(step);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [step]);

  return (
    <div className={styles.rightSide}>
      <div className={styles.bg}>
        <div className={styles.apricotBg} />
        <div className={styles.blueBg} />
      </div>
      <div className={classNames(styles.stepOne, { [styles.visible]: displayedStep === OnboardingSteps.STEP_ONE })}>
        {displayedStep === OnboardingSteps.STEP_ONE && <OnBoardingStepOne />}
      </div>
      <div className={classNames(styles.imgWrapper, displayedStep === OnboardingSteps.STEP_TWO && styles.visible)}>
        <img alt={t("onboarding step two")} src={StepTwoSvg} />
      </div>
      <div className={classNames(styles.imgWrapper, displayedStep === OnboardingSteps.STEP_THREE && styles.visible)}>
        <img alt={t("onboarding step three")} src={StepThreeSvg} />
      </div>
    </div>
  );
};

export default RightSideClips;
